var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect } from 'react';
import { DropdownMenuContext } from './DropdownMenu';
import { withFlightUI } from '../withFlightUI';
const Button = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { isOpen, setIsOpen } = React.useContext(DropdownMenuContext);
    const prevOpenState = useRef(isOpen);
    const buttonRef = useRef();
    useEffect(() => {
        if (!isOpen && prevOpenState.current === true)
            buttonRef.current.focus();
        prevOpenState.current = isOpen;
    }, [isOpen]);
    const clickHandler = () => {
        setIsOpen(o => !o);
        typeof rest.onClick === 'function' && rest.onClick();
    };
    return withFlightUI(children, Object.assign({ as: 'button', 'data-flight-dropdown-button': '', 'aria-expanded': isOpen, 'aria-haspopup': 'menu', type: 'button', role: 'button', ref: buttonRef, onClick: clickHandler }, rest));
};
export { Button };
//# sourceMappingURL=Button.js.map